/**
 * EWS Worker
 * Handles event writing service tasks
 */

import { Logger } from '@/shared/logger/logger';

import { AbstractWorker } from '../shared/abstract_worker';
import { EWSTaskProcessor } from './task_processor';

/**
 * Concrete worker class for EWS (Event Writer Service)
 */
export class EWSWorker extends AbstractWorker {
  /**
   * Worker name for logging and identification
   */
  protected readonly workerName = 'EWS';

  /**
   * Bundle name for the worker
   */
  protected readonly bundleName = 'ews';

  /**
   * Task processor instance
   */
  protected readonly taskProcessor = new EWSTaskProcessor();

  /**
   * Constructor
   * Initializes the worker
   */
  constructor() {
    super();
    this.initialize().catch(error => {
      Logger.error('Failed to initialize EWS worker:', error);
    });
  }
}

/**
 * Create and expose the worker instance
 */
const workerInstance = new EWSWorker();

// Make sure the worker is accessible in the global scope for debugging
// @ts-expect-error - Self in web workers can be extended with custom properties
self.ewsWorker = workerInstance;
